module.exports = __webpack_public_path__ + "img/Pasarelas14.f184cf50.jpg";